<template>
<v-card>
  <div class="pa-2 pa-sm-9"> 
    <v-row>
      <v-col cols="12" sm="6" style="margin-bottom: 0.5vh">
        <v-text-field
          ref="input"
          label="Nome"
          type="text"
          v-model="CurrentUser.name"
          filled
        ></v-text-field>
      </v-col>  
      
      <v-col class="d-none d-sm-inline-block" sm="6" style="margin-bottom: 0.5vh"></v-col>
      <v-col cols="12" sm="6" style="margin-bottom: 0.5vh">
        <v-text-field
          ref="input"
          label="Cognome"
          type="text"
          v-model="CurrentUser.surname"
          filled
        ></v-text-field>
      </v-col> 
    </v-row>

    <v-row>
     
      <v-col  cols="12" sm="6" style="margin-bottom: 0.5vh">
        <v-text-field
          ref="input"
          label="Username"
          type="text"
          v-model="CurrentUser.username"
          filled
          readonly
        ></v-text-field>
      </v-col> 
      <v-col  cols="12" sm="6" style="margin-bottom: 0.5vh">
        <v-text-field
          ref="input"
          label="Email"
          type="email" 
          
          v-model="CurrentUser.email"
          filled
        ></v-text-field>
      </v-col> 
      <!-- <v-col cols="6" style="margin-bottom: 0.5vh"></v-col> -->
      <v-col  cols="12" sm="6" style="margin-bottom: 0.5vh">
        <v-text-field
          ref="input"
          label="Password"

          type="password"
          v-model="CurrentUser.password"
          filled
          
        ></v-text-field>
      </v-col> 
 
    </v-row>
 
    <v-row>
      <!-- <v-col cols="6">
        <v-btn large color="error" block :to="{ name: 'dashboard' }">
          Indietro
        </v-btn>
      </v-col> -->

      <v-col cols="12">
        <v-btn large class="btnLogin" block @click="submit">
          Salva le modifiche
          <template v-slot:loader>
            <span>Saving...</span>
          </template>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</v-card>
</template>


<style lang="scss">
</style>


<script>
import EasyPlanClient from "../../utils/EasyPlanClient";
export default {
  data() {
    return {
      CurrentUser:{}, 
      CompanyData: {
        ragioneSociale: "",
        name:"",
        surname:"",
        email:"",
        partitaIVA: "",
        indirizzo: "",
        cap: "",
        citta: "",
        provincia: "",
        telefono: "",
      },
      loader: null,
    };
  },
  methods: {
    loadUser(userId) {
      console.debug("carico user");
      EasyPlanClient.User.Find( this.$route.params.companyAlias,userId)
        .then((res) => {
          console.debug(res);
          this.CurrentUser = res.data.data;
        })
        .catch((error) => {
          console.log(error);
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        });
    },
    loadCompanyInfo() {
      console.debug("carico companyInfo");
      EasyPlanClient.Company.FindByAlias(this.$route.params.companyAlias)
        .then((res) => {
          console.debug(res);
          this.CompanyData = res.data.data;
        })
        .catch((error) => {
          console.log(error);
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        });
    },
     editUser(user,callback=()=>{}) {
      console.debug("editing");
      console.debug(user);
      EasyPlanClient.User.Update(this.$route.params.companyAlias, user)
        .then((res) => {
          console.debug("risposta edit user:");
          console.debug(res);
          callback(res.data.data);
          this.loadUsers();
        })
        .catch((error) => {
          console.log(error);
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        });
    },
    submit: function () {
      console.debug("saving userr.....")
      this.editUser(this.CurrentUser,()=>{
         this.$router.push({
            name: "dashboard",
            params: { companyAlias: this.$route.params.companyAlias  },
          });
      });
      // if (
      //   !this.CompanyData.ragioneSociale.length > 0 &&
      //   this.CompanyData.partitaIVA.length > 0
      // ) {
      //   this.error = "Inserisci  i dati dell'azienda per proseguire";
      //   return "";
      // }
      // EasyPlanClient.Company.UpdateCompany(
      //   this.CompanyData.alias,
      //   this.CompanyData.ragioneSociale,
      //   this.CompanyData.partitaIva,
      //   this.CompanyData.indirizzo,
      //   this.CompanyData.cap,
      //   this.CompanyData.citta,
      //   this.CompanyData.provincia,
      //   this.CompanyData.telefono
      // )
      //   .then((res) => {
      //     console.debug("risposta add company:");
      //     console.debug(res);
      //     let companyAlias = res.data.data;

      //     this.$router.push({
      //       name: "login",
      //       params: { companyAlias: companyAlias },
      //     });
      //   })
      //   .catch((error) => {
      //     this.error = EasyPlanClient.GetErrorDescription(
      //       error.response.data.errorCode
      //     );
      //     console.error("si è verificato un errore" + this.error);
      //     console.error(error);
      //   });
    },
  },
  computed: {
    loaing: {
      get() {
        return this.loader.length > 0;
      },
    },
    ShowSnackbar: {
      get() {
        return this.error.length > 0;
      },
      set(value) {
        if (!value) this.error = "";
      },
    },
  },
  created: function () {
    // if (
    //   localStorage.userToken != undefined &&
    //   localStorage.userToken != "null"
    // ) {
    //   EasyPlanClient.SetJWT(localStorage.userToken);
    // }
    // this.loadCompanyInfo();
 
    if (
      localStorage.userToken == undefined ||
      localStorage.userToken == "null"
    ) {
      console.debug("logging off");
      localStorage.userToken = null;

      this.$router.push({
        name: "login",
        params: { companyAlias: this.$route.params.companyAlias },
      });
    }
      if (localStorage.currentUser != null) {
      this.CurrentUser = JSON.parse(localStorage.currentUser);
    }
    this.loadUser( this.CurrentUser.idUtente);

  },
};
</script>